import * as api from "./client";

export type IndustrySector = {
  id: string;
  name: string;
  slug: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
};

type IndustrySectorListResponse = {
  industrySectors: IndustrySector[];
  pagination: { limit: number; offset: number; hasMore: boolean };
};

type IndustrySectorSingleResponse = {
  industrySector: IndustrySector;
};

export type CreateIndustrySectorInput = {
  name: string;
};

export type UpdateIndustrySectorInput = {
  name?: string;
  slug?: string;
};

export type IndustrySectorField = "name" | "slug";

const BASE_PATH = "/v1/taxonomy/industry-sectors";
const PAGE_SIZE = 100;

export const industrySectors = {
  getAll: async (filters: { isActive?: boolean } = {}): Promise<IndustrySector[]> => {
    const all: IndustrySector[] = [];
    const activeFilter = filters.isActive === undefined ? "" : `&isActive=${filters.isActive}`;
    for (let offset = 0; ; offset += PAGE_SIZE) {
      const response = await api.get<IndustrySectorListResponse>(
        `${BASE_PATH}?limit=${PAGE_SIZE}&offset=${offset}${activeFilter}`,
      );
      all.push(...response.industrySectors);
      if (!response.pagination.hasMore) return all;
    }
  },

  create: async (data: CreateIndustrySectorInput): Promise<IndustrySector> => {
    const response = await api.post<IndustrySectorSingleResponse>(BASE_PATH, data);
    return response.industrySector;
  },

  update: async (id: string, data: UpdateIndustrySectorInput): Promise<IndustrySector> => {
    const response = await api.put<IndustrySectorSingleResponse>(`${BASE_PATH}/${id}`, data);
    return response.industrySector;
  },

  deactivate: async (id: string): Promise<IndustrySector> => {
    const response = await api.del<IndustrySectorSingleResponse>(`${BASE_PATH}/${id}`);
    return response.industrySector;
  },

  reactivate: async (id: string): Promise<IndustrySector> => {
    const response = await api.post<IndustrySectorSingleResponse>(`${BASE_PATH}/${id}/reactivate`);
    return response.industrySector;
  },
};

export function duplicateFieldOf(error: unknown): IndustrySectorField | null {
  const apiError = error as { code?: string; detailsRaw?: unknown } | null;
  if (apiError?.code !== "VALIDATION_ERROR") return null;
  const field = (apiError.detailsRaw as { field?: unknown } | undefined)?.field;
  return field === "name" || field === "slug" ? field : null;
}
